import React, { useRef, useState } from 'react';

import { TriangleDownIcon } from '@modernloop/shared/icons';
import { Button, MenuItemProps } from '@mui/material';

import DurationMenu, { MaxDuration, getDurationLabel } from 'src/components/DurationMenu';

type DurationPickerProps = {
  dataTestId?: string;
  duration: number;
  maxDuration?: MaxDuration;
  onChange: (value: number) => void;
  additionalOptions?: MenuItemProps[];
};

const DurationPicker = ({
  additionalOptions,
  dataTestId,
  duration,
  maxDuration,
  onChange,
}: DurationPickerProps): JSX.Element => {
  const [showDurationMenu, setShowDurationMenu] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  // Caller-supplied options keep their own labels; fall back to the locale-aware duration label.
  let durationString = additionalOptions?.find((option) => Number(option.id) === duration)?.value as string | undefined;

  if (!durationString) {
    durationString = getDurationLabel(duration);
  }
  const handleToggleMinTimeBlockMenu = () => setShowDurationMenu(!showDurationMenu);
  const handleDurationSelect = (mins: number) => {
    handleToggleMinTimeBlockMenu();
    onChange(mins);
  };

  return (
    <>
      <Button
        data-testid={dataTestId}
        sx={{
          borderRadius: '6px',
          fontWeight: (theme) => theme.typography.fontWeightRegular,
          minWidth: '200px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
        ref={buttonRef}
        endIcon={<TriangleDownIcon />}
        onClick={handleToggleMinTimeBlockMenu}
      >
        {durationString}
      </Button>
      {showDurationMenu && (
        <DurationMenu
          id="min-time-block"
          selected={duration}
          maxDuration={maxDuration}
          additionalOptions={additionalOptions}
          open
          anchorEl={buttonRef}
          onClose={handleToggleMinTimeBlockMenu}
          onSelect={handleDurationSelect}
        />
      )}
    </>
  );
};

export default DurationPicker;
